export default __webpack_public_path__ + "static/media/11-68.5e4822f9.png";